$('.content_bottom_appendto').appendTo('.products-container').css('margin-top','40px');

$('.cross-page-promos .carousel').owlCarousel({
    loop: false,
    navigation: false,
    nav: true,
    navText:["<svg style='width: 10px;height: 10px;fill:transparent;' xmlns='http://www.w3.org/2000/svg' width='7' height='12' viewBox='0 0 7 12' fill='none'><path d='M6 1.08032L1 6.11691L6 11.1535' stroke='#647380' stroke-linejoin='round'/></svg>",
    "<svg style='width: 10px;height: 10px;fill:transparent;' xmlns='http://www.w3.org/2000/svg' width='7' height='12' viewBox='0 0 7 12' fill='none'><path d='M1 11.1536L6 6.11697L1 1.08038' stroke='#647380' stroke-linejoin='round'/></svg>"],
    item: 1,
    dots: false,
    responsive: { 
      0: {
        items: 1
      },
      576: {
        items: 1
      },
      768: {
        items: 1
      }
    }
})


$('#store-messages-mobile .container').owlCarousel({
    loop: false,
    navigation: false,
    nav: true,
    navText:["<svg style='width: 10px;height: 10px;fill:transparent;' xmlns='http://www.w3.org/2000/svg' width='7' height='12' viewBox='0 0 7 12' fill='none'><path d='M6 1.08032L1 6.11691L6 11.1535' stroke='#647380' stroke-linejoin='round'/></svg>",
    "<svg style='width: 10px;height: 10px;fill:transparent;' xmlns='http://www.w3.org/2000/svg' width='7' height='12' viewBox='0 0 7 12' fill='none'><path d='M1 11.1536L6 6.11697L1 1.08038' stroke='#647380' stroke-linejoin='round'/></svg>"],
    item: 1,
    dots: false,
    responsive: { 
      0: {
        items: 1
      },
      576: {
        items: 1
      },
      768: {
        items: 1
      }
    }
})

$('#store-messages .main-search__close').click(function() {
    console.log("#store-messages .main-search__close");
  
    $('.section-store-messages').remove();
});
  

$('.collection-parent-template .left-sidebar.mobile-only .navigation__children-toggle').click(function () {
    if ($(this).parent().toggleClass('navigation__item--mobile-open').hasClass('navigation__item--mobile-open')) {
      $(this).siblings('.navigation__child-tier').stop().slideDown(300, function () {
        $(this).parent().addClass('navigation__item--mobile-open-finished');
        $(this).removeAttr('style');
      });
    } else {
      $(this).siblings('.navigation__child-tier').stop().slideUp(300, function () {
        $(this).parent().removeClass('navigation__item--mobile-open-finished');
        $(this).removeAttr('style');
      });
    }
  
    return false;
});
  
$('.product-detail .product-accordion-infos .navigation__children-toggle').click(function () {
    if ($(this).parent().toggleClass('navigation__item--mobile-open').hasClass('navigation__item--mobile-open')) {
      $(this).siblings('.navigation__child-tier').stop().slideDown(300, function () {
        $(this).parent().addClass('navigation__item--mobile-open-finished');
        $(this).removeAttr('style');
      });
    } else {
      $(this).siblings('.navigation__child-tier').stop().slideUp(300, function () {
        $(this).parent().removeClass('navigation__item--mobile-open-finished');
        $(this).removeAttr('style');
      });
    }
  
    return false;
});


/* collection filter */

$('.mobile-filter-button span').click(function() {
    $('.mobile-filter.mobile-only').addClass('show');
});
  
$('.mobile-filter.mobile-only .close-toggle').click(function() {
    console.log("close-toggle");
  
  $('.mobile-filter.mobile-only').removeClass('show');
});

$('.promotion_slider').each(function(index){
  $(this).owlCarousel({
    loop: false,
    navigation: true,
    nav: true,
    navText:["",
    "<svg xmlns='http://www.w3.org/2000/svg' width='37' height='15' viewBox='0 0 37 15' fill='none'><g clip-path='url(#clip0)'><path d='M0 7.3999H35.6' stroke='#272727' stroke-linejoin='round'/><path d='M28.6001 0.399902L35.6001 7.3999L28.6001 14.3999' stroke='#272727' stroke-linejoin='round'/></g><defs><clipPath id='clip0'><rect width='36.1' height='14.7' fill='white'/></clipPath></defs></svg>"],
    item: 5,
    dots: false,
    responsive: {
      992: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
})
});

$('.thumbnail-wrapper.slideshow').owlCarousel({
    loop: false,
    navigation: false,
    nav: true,
    navText:["<svg xmlns='http://www.w3.org/2000/svg' width='9' height='18' viewBox='0 0 9 18' fill='none' style='fill: transparent;'><path d='M7.71436 1.5L1.28578 9L7.71435 16.5' stroke='#272727' stroke-width='2' stroke-linejoin='round'/></svg>",
    "<svg xmlns='http://www.w3.org/2000/svg' width='9' height='18' viewBox='0 0 9 18' fill='none' style='fill: transparent;'><path d='M1.28564 16.5L7.71422 9L1.28564 1.5' stroke='#272727' stroke-width='2' stroke-linejoin='round'/></svg>"],
    item: 1,
    dots: false,
    responsive: { 
      0: {
        items: 1
      },
      576: {
        items: 1
      },
      768: {
        items: 1
      },
      992: {
        items: 1
      },
      1200: {
        items: 1
      }
    }
})

// Wishlist start
function loadWishlistCount() {
  window._swat.wishlistCount(
    function(r) {
      $('body #swym-wishlist--count').addClass('active').html(r);
    }
  );
}

window.addEventListener('DOMContentLoaded', (event) => {
  function detectSwym() {
    if(typeof(window._swat) !== 'undefined') setTimeout(loadWishlistCount, 500);
    else setTimeout(detectSwym, 100);
  }
  setTimeout(detectSwym, 100);
});
// Wishlist end

function processUrl(path, tags, query) {
  var query = query.replace(/\page=(\w+)&/, ''),
      urlString = '';

  if (path.indexOf("/all") > -1 && tags.indexOf("all") > -1) {
    urlString = path.trim() + query.trim();
  } else {
    urlString = path.trim() + tags.trim() + query.trim();
  }

  console.log('processUrl -> urlString = ', urlString);

  updateView(urlString);
}

function updateView(filterURL) {

  jQuery.ajax({
    type: 'GET',
    url: filterURL,
    beforeSend: function beforeSend() {
//      $(".products-grid").addClass('fadeOut animated loading-in-progress');
    },
    success: function success(data) {},
    error: function error(x, t, m) {
      location.replace(location.protocol + '//' + location.host + filterURL);
    },
    dataType: "html"
  }).then(function (data) {
    var $collectionMain = $('.products-container'); // Get and set new breadcrumb html

    var filteredData = $(data).find('.collection-listing');
    var filteredPageLinks = $(data).find('.pagination-row');
    var noProducts = $(data).find('.no-products-container');

    if (filteredData.length) {
      // Add products to container
      $collectionMain.empty();
      $collectionMain.append(filteredData);
    } else {
      // Display no product message
      $collectionMain.empty();
      $collectionMain.append(noProducts);
    }

    $collectionMain.append(filteredPageLinks);
    window.history && window.history.pushState && window.history.pushState("", "", filterURL);
  });

};

!function () {
  var a = function () {
    function a() {}

    function b(a) {
      return decodeURIComponent(a.replace(/\+/g, " "));
    }

    function c(a, b) {
      var c = a.charAt(0),
          d = b.split(c);
      return c === a ? d : (a = parseInt(a.substring(1), 10), d[a < 0 ? d.length + a : a - 1]);
    }

    function d(a, c) {
      for (var d = a.charAt(0), e = c.split("&"), f = [], g = {}, h = [], i = a.substring(1), j = 0, k = e.length; j < k; j++) {
        if (f = e[j].match(/(.*?)=(.*)/), f || (f = [e[j], e[j], ""]), "" !== f[1].replace(/\s/g, "")) {
          if (f[2] = b(f[2] || ""), i === f[1]) return f[2];
          h = f[1].match(/(.*)\[([0-9]+)\]/), h ? (g[h[1]] = g[h[1]] || [], g[h[1]][h[2]] = f[2]) : g[f[1]] = f[2];
        }
      }

      return d === a ? g : g[i];
    }

    return function (b, e) {
      var f,
          g = {};
      if ("tld?" === b) return a();
      if (e = e || window.location.toString(), !b) return e;
      if (b = b.toString(), f = e.match(/^mailto:([^\/].+)/)) g.protocol = "mailto", g.email = f[1];else {
        if ((f = e.match(/(.*?)\/#\!(.*)/)) && (e = f[1] + f[2]), (f = e.match(/(.*?)#(.*)/)) && (g.hash = f[2], e = f[1]), g.hash && b.match(/^#/)) return d(b, g.hash);
        if ((f = e.match(/(.*?)\?(.*)/)) && (g.query = f[2], e = f[1]), g.query && b.match(/^\?/)) return d(b, g.query);
        if ((f = e.match(/(.*?)\:?\/\/(.*)/)) && (g.protocol = f[1].toLowerCase(), e = f[2]), (f = e.match(/(.*?)(\/.*)/)) && (g.path = f[2], e = f[1]), g.path = (g.path || "").replace(/^([^\/])/, "/$1"), b.match(/^[\-0-9]+$/) && (b = b.replace(/^([^\/])/, "/$1")), b.match(/^\//)) return c(b, g.path.substring(1));
        if (f = c("/-1", g.path.substring(1)), f && (f = f.match(/(.*?)\.(.*)/)) && (g.file = f[0], g.filename = f[1], g.fileext = f[2]), (f = e.match(/(.*)\:([0-9]+)$/)) && (g.port = f[2], e = f[1]), (f = e.match(/(.*?)@(.*)/)) && (g.auth = f[1], e = f[2]), g.auth && (f = g.auth.match(/(.*)\:(.*)/), g.user = f ? f[1] : g.auth, g.pass = f ? f[2] : void 0), g.hostname = e.toLowerCase(), "." === b.charAt(0)) return c(b, g.hostname);
        a() && (f = g.hostname.match(a()), f && (g.tld = f[3], g.domain = f[2] ? f[2] + "." + f[3] : void 0, g.sub = f[1] || void 0)), g.port = g.port || ("https" === g.protocol ? "443" : "80"), g.protocol = g.protocol || ("443" === g.port ? "https" : "http");
      }
      return b in g ? g[b] : "{}" === b ? g : void 0;
    };
  }();

  "function" == typeof window.define && window.define.amd ? window.define("js-url", [], function () {
    return a;
  }) : ("undefined" != typeof window.jQuery && window.jQuery.extend({
    url: function url(a, b) {
      return window.url(a, b);
    }
  }), window.url = a);
}();

var queryParameters = {};

let sortfilter = null;
let customfilter_1 = null;
let customfilter_2 = null;
let customfilter_3 = null;

let sortfilter_class_mobile = '.sortfilter_mobile';
let customfilter_1_class_mobile = '.customfilter_mobile_1';
let customfilter_2_class_mobile = '.customfilter_mobile_2';
let customfilter_3_class_mobile = '.customfilter_mobile_3';

$(document).ready(function(){
  sortfilter = $('.sortfilter')[0];
  customfilter_1 = $('.customfilter_1')[0];
  customfilter_2 = $('.customfilter_2')[0];
  customfilter_3 = $('.customfilter_3')[0];
});

function _filterURL() {
  var selectedOptions = [],
      query = '',
      currentTags = '',
      siteUrl = 'https://' + url('hostname'),
      url1 = url('1') ? '/' + url('1') + '/' : '',
      url2 = url('2') ? url('2') + '/' : '',
      url3 = url('3'),
      path = url1 + url2; //Handle dropdowns if they exist

  if (sortfilter != null) {
    if ($(window).width() < 768) {  // mobile filter
      query = $('input'+ sortfilter_class_mobile + ':checked' ).val();
    } else {
      query = $(sortfilter).val();  // desktop filter
    }

    if (query != null) {
      $('input' + sortfilter_class_mobile + '#' + query ).prop("checked", true);
      $(sortfilter).val(query);
    }
  }

  if (customfilter_1 != null) {
    var tagValue = $(window).width() < 768 ? $('input'+ customfilter_1_class_mobile + ':checked' ).val() : $(customfilter_1).val();

    if ($(customfilter_1).data('default-filter') != tagValue) {
      var urlTag = tagValue.substr(tagValue.lastIndexOf('/') + 1);  

      if (urlTag != 'all') {
        if ($.inArray(urlTag, selectedOptions) > -1) { //Do nothing
          console.log('customfilter_1 - do nothing');
        } else {
          selectedOptions.unshift(urlTag);
        }
      }

      console.log("urlTag == ", urlTag);

      $('input' + customfilter_1_class_mobile + '#' + urlTag ).prop("checked", true);
      $(customfilter_1).val(urlTag);
    }
  } else {
    console.log('customfilter_1 is null');
  }

  if (customfilter_2 != null) {
    var tagValue = $(window).width() < 768 ? $('input'+ customfilter_2_class_mobile + ':checked' ).val() : $(customfilter_2).val();

    if ($(customfilter_2).data('default-filter') != tagValue) {
      var urlTag = tagValue.substr(tagValue.lastIndexOf('/') + 1);  

      if (urlTag != 'all') {
        if ($.inArray(urlTag, selectedOptions) > -1) { //Do nothing
          console.log('customfilter_1 - do nothing');
        } else {
          selectedOptions.unshift(urlTag);
        }
      }

      $('input' + customfilter_2_class_mobile + '#' + urlTag ).prop("checked", true);
      $(customfilter_2).val(urlTag);
    }
  } else {
    console.log('customfilter_1 is null');
  }

  if (customfilter_3 != null) {
    var tagValue = $(window).width() < 768 ? $('input'+ customfilter_3_class_mobile + ':checked' ).val() : $(customfilter_3).val();

    if ($(customfilter_3).data('default-filter') != tagValue) {
      var urlTag = tagValue.substr(tagValue.lastIndexOf('/') + 1);  

      if (urlTag != 'all') {
        if ($.inArray(urlTag, selectedOptions) > -1) { //Do nothing
          console.log('customfilter_1 - do nothing');
        } else {
          selectedOptions.unshift(urlTag);
        }
      }
      
      console.log('urltag = ' + urlTag);

      $('input' + customfilter_3_class_mobile + '#' + urlTag ).prop("checked", true);
      $(customfilter_3).val(urlTag);
    }
  } else {
    console.log('customfilter_1 is null');
  }

  selectedOptions = jQuery.makeArray(selectedOptions);

  jQuery.each(selectedOptions, function (i, value) {
    if (i != selectedOptions.length - 1) {
      currentTags += selectedOptions[i] + '+';
    } else {
      currentTags += selectedOptions[i];
    }
  });

  queryParameters.sort_by = query;
  query = '?' + jQuery.param(queryParameters);

  console.log("path = ", path);
  console.log("currentTags = ", currentTags);
  console.log("query = ", query);

  processUrl(path, currentTags, query);
};


function _reset_filterURL() {
  var selectedOptions = [],
    query = '',
    currentTags = '',
    siteUrl = 'https://' + url('hostname'),
    url1 = url('1') ? '/' + url('1') + '/' : '',
    url2 = url('2') ? url('2') + '/' : '',
    url3 = url('3'),
    path = url1 + url2; //Handle dropdowns if they exist

    selectedOptions = jQuery.makeArray(selectedOptions);

  jQuery.each(selectedOptions, function (i, value) {
    if (i != selectedOptions.length - 1) {
      currentTags += selectedOptions[i] + '+';
    } else {
      currentTags += selectedOptions[i];
    }
  });

  queryParameters.sort_by = query;
  query = '?' + jQuery.param(queryParameters);

  console.log("path = ", path);
  console.log("currentTags = ", currentTags);
  console.log("query = ", query);

  $('.tagfilters').each(function(index){
    $(this).val('placeholder-value');
  })

  $('.tagfilters_mobile').each(function(index) {
    $(this).prop('checked', false);
  });

  processUrl(path, currentTags, query);
}

$('.tagfilters, .tagfilters_mobile').on('change', function () {
  console.log('tag filter change event');
  _filterURL();
});

$('.reset_filter').on('click', function() {
  _reset_filterURL();
  console.log('reset button clicked');
});


window.okeReviewsWidgetOnInit = function (okeInitApi) {
  window.refreshOkendo = function () {
      okeInitApi.initCoreWidgets();
  };
};

if (typeof window.refreshOkendo === 'function') { window.refreshOkendo(); }

// Upusell slider in cart drawer
window.addEventListener('DOMContentLoaded', (event) => {
  $('.mini-cart-upsell .upsell-products').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button">'+ theme.icons.chevronLeft +'</button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button">'+ theme.icons.chevronRight +'</button>'
  });
});

